/**
 * Seaches a url query string for a parameter
 *
 * @param  {String} name [name of the query param to search]
 * @param  {String} url  [window location]
 * @return {String}
 */
export default function getParamByName(name, url) {
  let queryName = name.replace(/[\[\]]/g, "\\$&");
  let regex = new RegExp("[?&]" + queryName + "(=([^&#]*)|&|#|$)");
  let results = regex.exec(url);

  if (!results) return null;

  if (!results[2]) return '';

  return decodeURIComponent(results[2].replace(/\+/g, " "));
}



// WEBPACK FOOTER //
// ./src/client/utils/get-param-by-name.js